import { Modal } from "antd";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import useForm from "../../hooks/useForm";
import { useThunk } from "../../hooks/useThunk";
import { COMMON_FIELD_TYPES } from "../../constants/fieldTypes";
import { roles } from "../../constants/commonConstants";
import {
  closeSignInModal,
  signin,
  startDataRefresh,
  requestOTP,
} from "../../store";

import CustomInput from "../Form/Input";
import CustomButton from "../Form/CustomButton";
import showToast from "../../utils/toastNotifications";

const ForgotPassword = ({
  isOpen,
  onClose,
  onOtpSent,
  onBack,
  isModel = false,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const { role } = useSelector((state) => state.auth);

  const [accNotFoundErr, setAccNotFoundErr] = useState(false);

  const [doSignin, isSigninIn, signinError] = useThunk(signin);

  const [doRequestOtp, isRequestingOtp] = useThunk(requestOTP);

  const emailErrContent = (
    <div className="absolute top-0 w-full mt-4 flex flex-col gap-2 justify-center items-center text-center">
      <svg
        width="52"
        height="47"
        viewBox="0 0 52 47"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M52 13.6053C52 17.2136 50.5651 20.6742 48.0111 23.2256C45.457 25.7771 41.993 27.2105 38.381 27.2105C34.769 27.2105 31.3049 25.7771 28.7508 23.2256C26.1968 20.6742 24.7619 17.2136 24.7619 13.6053C24.7619 9.99692 26.1968 6.53637 28.7508 3.98489C31.3049 1.43341 34.769 0 38.381 0C41.993 0 45.457 1.43341 48.0111 3.98489C50.5651 6.53637 52 9.99692 52 13.6053ZM38.381 4.94737C38.0526 4.94737 37.7377 5.07768 37.5055 5.30963C37.2733 5.54158 37.1429 5.85618 37.1429 6.18421V16.0789C37.1429 16.407 37.2733 16.7216 37.5055 16.9535C37.7377 17.1855 38.0526 17.3158 38.381 17.3158C38.7093 17.3158 39.0242 17.1855 39.2564 16.9535C39.4886 16.7216 39.619 16.407 39.619 16.0789V6.18421C39.619 5.85618 39.4886 5.54158 39.2564 5.30963C39.0242 5.07768 38.7093 4.94737 38.381 4.94737ZM38.381 22.5724C38.5842 22.5724 38.7854 22.5324 38.9732 22.4547C39.161 22.377 39.3316 22.2631 39.4753 22.1195C39.619 21.976 39.733 21.8055 39.8108 21.618C39.8885 21.4304 39.9286 21.2293 39.9286 21.0263C39.9286 20.8233 39.8885 20.6222 39.8108 20.4347C39.733 20.2471 39.619 20.0767 39.4753 19.9331C39.3316 19.7895 39.161 19.6756 38.9732 19.5979C38.7854 19.5203 38.5842 19.4803 38.381 19.4803C37.9705 19.4803 37.5769 19.6432 37.2866 19.9331C36.9964 20.223 36.8333 20.6163 36.8333 21.0263C36.8333 21.4364 36.9964 21.8296 37.2866 22.1195C37.5769 22.4095 37.9705 22.5724 38.381 22.5724ZM45.8095 38.9605V27.8735C47.1684 27.1658 48.4191 26.2678 49.5238 25.2068V38.9605C49.5239 41.014 48.7375 42.9897 47.3258 44.4824C45.914 45.975 43.9841 46.8714 41.9318 46.9876L41.4762 47H8.04762C5.99204 47.0001 4.01433 46.2145 2.52019 44.8042C1.02605 43.3939 0.128759 41.4659 0.0123813 39.4157L1.72719e-08 38.9605V15.4605C-0.000134573 13.407 0.786325 11.4313 2.19804 9.93869C3.60976 8.44607 5.53972 7.54968 7.592 7.43342L8.04762 7.42105H23.5189C23.0229 8.61156 22.672 9.85735 22.4739 11.1316H8.04762C6.9601 11.1316 5.91236 11.5402 5.11237 12.2761C4.31237 13.012 3.81863 14.0216 3.72914 15.1043L3.71429 15.4605V16.5217L24.7619 27.589L27.9933 25.8871C29.0804 26.8048 30.2888 27.5816 31.5937 28.1876L25.6261 31.3267C25.3984 31.4462 25.1483 31.5172 24.8917 31.5351C24.6351 31.553 24.3776 31.5174 24.1354 31.4306L23.8977 31.3267L3.71429 20.7146V38.9605C3.71433 40.0469 4.12328 41.0936 4.85997 41.8928C5.59666 42.692 6.60722 43.1852 7.69105 43.2746L8.04762 43.2895H41.4762C42.5641 43.2894 43.6122 42.8805 44.4122 42.144C45.2123 41.4076 45.7058 40.3974 45.7947 39.3143L45.8095 38.9605Z"
          fill="#FF3B30"
        />
      </svg>
      <p className="text-error-roselea-red text-[18px]">
        Please enter your email address.
      </p>
    </div>
  );

  const accNotFoundErrContent = (
    <div className="w-full mt-4 flex flex-col gap-2 justify-center items-center text-center">
      <svg
        width="52"
        height="48"
        viewBox="0 0 52 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M34.6597 9.13035C32.536 7.00278 29.8298 5.55394 26.8836 4.96719C23.9374 4.38043 20.8836 4.68213 18.1087 5.8341C15.3338 6.98607 12.9624 8.93654 11.2948 11.4387C9.62712 13.9408 8.73811 16.8821 8.74024 19.8904L8.74158 21.2286C8.74213 21.7813 8.29425 22.2296 7.74158 22.2296H5.07115C4.51886 22.2296 4.07115 21.7819 4.07115 21.2296V19.8904C4.06993 16.7195 4.826 13.5943 6.27627 10.7756C7.72654 7.95692 9.82895 5.52647 12.408 3.68709C14.9871 1.84771 17.9681 0.652764 21.1022 0.201963C24.2362 -0.248839 27.4325 0.0575838 30.4243 1.09566C33.4161 2.13373 36.1165 3.87335 38.3003 6.16934C40.4841 8.46533 42.0879 11.2511 42.9779 14.2941C43.8678 17.3372 44.0182 20.5493 43.4163 23.6624C42.8706 26.4846 41.7211 29.1513 40.0508 31.4805C39.7558 31.8919 39.7871 32.4593 40.1447 32.8175L51.2946 43.9859C51.6844 44.3763 51.6843 45.0086 51.2945 45.399L49.405 47.2913C49.0143 47.6825 48.3803 47.6825 47.9897 47.2912L36.8445 36.1275C36.4858 35.7682 35.9164 35.7371 35.5044 36.0337C32.1363 38.4588 28.0855 39.7681 23.9224 39.7639H22.5867C22.0344 39.7639 21.5867 39.3161 21.5867 38.7639V36.0856C21.5867 35.5333 22.0344 35.0856 22.5867 35.0856H23.9224C26.925 35.0854 29.8601 34.1935 32.3567 32.5228C34.8532 30.8521 36.799 28.4776 37.948 25.6995C39.097 22.9213 39.3977 19.8643 38.8119 16.9151C38.2262 13.9658 36.7804 11.2567 34.6573 9.13035M2.59495 27.0394C2.9856 26.6479 3.61986 26.6479 4.01058 27.0393L9.20047 32.2387C9.59109 32.63 10.2252 32.63 10.6158 32.2388L15.808 27.039C16.1987 26.6477 16.8329 26.6478 17.2235 27.0393L19.1135 28.9334C19.5031 29.3239 19.503 29.956 19.1132 30.3463L13.9187 35.5485C13.5289 35.9389 13.5289 36.5713 13.9187 36.9617L19.1132 42.1639C19.503 42.5542 19.5031 43.1864 19.1135 43.5768L17.2235 45.471C16.8329 45.8624 16.1987 45.8625 15.808 45.4712L10.6158 40.2715C10.2252 39.8802 9.59109 39.8803 9.20047 40.2716L4.01058 45.471C3.61986 45.8624 2.9856 45.8624 2.59495 45.4708L0.70505 43.5768C0.315454 43.1864 0.315565 42.5542 0.705299 42.1639L5.89985 36.9617C6.28968 36.5713 6.28968 35.9389 5.89985 35.5485L0.705299 30.3463C0.315565 29.956 0.315454 29.3239 0.70505 28.9334L2.59495 27.0394Z"
          fill="#FF3B30"
        />
      </svg>
      <p className="text-error-roselea-red text-[18px]">
        No account found with this email address.
      </p>
    </div>
  );

  const {
    formData,
    errors,
    touched,
    handleInputChange,
    handleBlur,
    validateForm,
    setTouched,
    setFormData,
    clearError,
  } = useForm(
    {
      email: "",
    },
    {
      email: true,
    },
    {
      email: COMMON_FIELD_TYPES.EMAIL_FIELD,
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    setTouched({ email: true });
    setAccNotFoundErr(false); // Reset error

    if (validateForm()) {
      const { email } = formData;

      const result = await doRequestOtp({ emailOrPhone: email });

      if (result?.success) {
        showToast("success", "OTP sent to your email");
        onOtpSent(email); // Proceed to next step (OTP input)
      } else {
        showToast("error", result?.error?.message || "Failed to send OTP");
        if (
          result?.error?.message?.toLowerCase().includes("no user") ||
          result?.error?.httpStatus === 404
        ) {
          setAccNotFoundErr(true); // Trigger "account not found" error UI
        }
      }
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={500}
      centered
      className="confirmation-modal relative"
      style={{
        backgroundColor: "#F6FCFF",
        borderRadius: "40px",
      }}
    >
      <div className="h-[400px] sm:h-[450px] max-w-[547px] flex flex-col items-center justify-start my-4 sm:my-8">
        <h1 className="text-auth-level-1 font-semibold mb-4 font-poppins">
          <span className="text-roselea-green">Forgot </span>
          <span className="text-roselea-pink">Password</span>
        </h1>

        <p className="font-poppins text-[14px] sm:text-[16px] text-text-roselea-gray text-center">
          Enter your email address and we’ll send you a OTP to reset your
          password
        </p>

        <form className="w-full">
          <div className="flex flex-col gap-3 mt-[24px] sm:mt-[40px]">
            <CustomInput
              label=""
              type="text"
              name="email"
              value={formData.email}
              error={
                touched.email &&
                (errors.email || accNotFoundErr) &&
                (accNotFoundErr ? accNotFoundErrContent : emailErrContent)
              }
              onChange={(e) => handleInputChange("email", e.target.value)}
              onBlur={() => handleBlur("email", formData.email)}
              onFocus={() => clearError("email")}
              placeholder="Enter your email address"
              className="w-full h-[54px] px-3 rounded-lg border border-input-border-roselea-green bg-primary-light/30 text-gray-600"
              labelStyle="font-alexandria font-medium  sm:text-[16px] text-dark"
              inputStyle="bg-input-roselea-green bg-opacity-[0.03]"
              isRequired={true}
            />
          </div>

          {/* {accNotFoundErr && accNotFoundErrContent} */}

          <div className="absolute bottom-[30px] sm:bottom-[60px] left-0 w-full p-[20px]">
            <CustomButton
              type="submit"
              className="h-[50px] sm:h-[45px] bg-roselea-pink text-roselea-white font-poppins font-semibold text-[16px] leading-[28px] rounded-[12px]"
              buttonText="Send OTP"
              onClick={handleSubmit}
              loading={isRequestingOtp}
              disabled={isRequestingOtp}
            />

            <div className="flex justify-center mt-4">
              <span className="text-sm text-gray-500">
                Back to Sign in?&nbsp;
                <Link
                  to="/forgot-password"
                  className="font-medium underline text-roselea-pink font-poppins text-[12px] sm:text-[14px] toc-link-forgot-password"
                  onClick={(e) => {
                    e.preventDefault();
                    if (onBack) onBack();
                  }}
                >
                  Sign in
                </Link>
              </span>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default ForgotPassword;
